import CommunitiesLayout from "./Layout";
import NotificationsApp from "../../communities/pages/notifications/App";

function Notifications() {
  return <NotificationsApp />;
}
Notifications.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>;
export default Notifications;
